/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/get_email_client_metadata/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdGetEmailClientMetadataId } from "./constants";
import type { EngagementGetEmailClientMetadataResult, GetEngagementGetEmailClientMetadataParams } from "./types";

export const getEngagementGetEmailClientMetadata = reactQueryFetcherAdapter(
  engagementAppGroupIdGetEmailClientMetadataId,
  (
    signal: AbortSignal,
    { appGroupId, testId }: GetEngagementGetEmailClientMetadataParams
  ): Promise<EngagementGetEmailClientMetadataResult> => {
    return fetch(
      `/engagement/${appGroupId}/get_email_client_metadata/${testId}`,
      "GET",
      {},
      { signal },
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
